import * as React from "react";
import { useTheme } from "@mui/material";

function PlayStoreIcon(props) {
  const theme = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={110}
      height={40}
      viewBox="0 0 110 40"
      display="block"
      {...props}
    >
      <title>{"F455A5CC-D2E2-48B1-A82D-44FCE13B067B"}</title>
      <defs>
        <linearGradient
          x1={60.157}
          y1={91.848}
          x2={33.558}
          y2={-59.589}
          id="prefix__a"
        >
          <stop stopColor="#D6FFA1" offset={0} />
          <stop stopColor="#93E2A7" offset={32.64} />
          <stop stopColor="#00A3B5" offset={100} />
        </linearGradient>
        <linearGradient
          x1={-32.172}
          y1={-129.736}
          x2={80.167}
          y2={113.998}
          id="prefix__b"
        >
          <stop stopColor="#FF177B" offset={0} />
          <stop stopColor="#FFA976" offset={67.21} />
          <stop stopColor="#FFEC73" offset={100} />
        </linearGradient>
        <linearGradient
          x1={50.819}
          y1={74.663}
          x2={-0.029}
          y2={-29.336}
          id="prefix__c"
        >
          <stop stopColor="#63FFD4" offset={0} />
          <stop stopColor="#32A0BA" offset={48.54} />
          <stop stopColor="#1262A9" offset={83.49} />
          <stop stopColor="#064AA2" offset={100} />
        </linearGradient>
        <linearGradient
          x1={119.508}
          y1={35.535}
          x2={-23.112}
          y2={61.013}
          id="prefix__d"
        >
          <stop stopColor="#FF4521" offset={0} />
          <stop stopColor="#D43E65" offset={34.11} />
          <stop stopColor="#9F36B9" offset={79.35} />
          <stop stopColor="#8A33DB" offset={100} />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <rect fill={theme.palette.error.dark} width={110} height={40} rx={4} />
        <path d="M16.625 25.417l2.791-2.834-2.79 2.834-9-9 9 9-9 9 9-9 2.832 2.833z" />
        <path
          d="M12.333 6.333l-10.958-6C1.083.167.792.125.542.208l9 8.959 2.791-2.834z"
          fill="url(#prefix__a)"
          transform="translate(7.083 16.25)"
        />
        <path
          d="M12.375 12l3.75-2.042c.75-.416.75-1.083 0-1.5l-3.75-2.083-2.833 2.792L12.375 12z"
          fill="url(#prefix__b)"
          transform="translate(7.083 16.25)"
        />
        <path
          d="M.542.167C.208.292 0 .625 0 1.125v16.083c0 .5.208.834.542.959l9-9-9-9z"
          fill="url(#prefix__c)"
          transform="translate(7.083 16.25)"
        />
        <path
          d="M.542 18.167c.25.083.541.041.833-.125L12.333 12 9.542 9.167l-9 9z"
          fill="url(#prefix__d)"
          transform="translate(7.083 16.25)"
        />
        <g fill={theme.palette.common.white}>
          <path d="M97.801 32.5l4.699-10.834h-1.53l-2.174 5.402h-.031l-2.234-5.402H95l3.092 7.044-1.745 3.79h1.454M91.25 21.666c-1.881 0-2.783 1.123-3.043 1.805l1.284.546c.26-.698 1.01-1.077 1.79-1.077 1.055 0 1.957.683 1.957 1.805v.212c-.291-.166-1.025-.455-2.034-.455-1.758 0-3.287.91-3.287 2.594 0 1.547 1.269 2.487 2.798 2.487 1.284 0 2.049-.652 2.461-1.274h.062v1.031h1.345v-4.489c0-2.093-1.498-3.185-3.333-3.185zm-.306 6.643c-.734 0-1.559-.394-1.559-1.183 0-.683.581-1.47 2.064-1.47 1.192 0 1.789.484 1.789.484 0 1.213-1.178 2.17-2.294 2.17zM85.833 18.75h1.25v10.833h-1.25zM81.193 18.75H77.5v10.833h1.393v-4.388h2.3c1.801 0 3.39-1.33 3.39-3.222s-1.589-3.223-3.39-3.223zm.03 5.114h-2.33v-3.783h2.33c1.241 0 1.937 1.03 1.937 1.892 0 .862-.696 1.891-1.937 1.891zM67.702 25.894a2.012 2.012 0 011.935-2.125c.645 0 1.191.318 1.373.773l-3.308 1.352zm2.061 3.753c1.696 0 2.677-1.022 3.084-1.615l-1.262-.827c-.42.607-.995 1.007-1.822 1.007-.827 0-1.416-.373-1.794-1.104l4.948-2.014-.169-.414c-.308-.814-1.247-2.318-3.167-2.318-1.907 0-3.491 1.476-3.491 3.642 0 2.042 1.57 3.643 3.673 3.643zM63.679 29.426h1.626V18.72h-1.626zM59.039 32.916c1.907 0 3.519-1.103 3.519-3.794v-6.54h-1.542v.594h-.056c-.365-.428-1.066-.814-1.949-.814-1.85 0-3.546 1.6-3.546 3.656 0 2.042 1.696 3.63 3.546 3.63.883 0 1.584-.388 1.949-.829h.056v.524c0 1.393-.757 2.14-1.977 2.14-.995 0-1.611-.705-1.864-1.298l-1.416.58c.407.965 1.486 2.151 3.28 2.151zm.113-4.704c-1.122 0-2.061-.925-2.061-2.194 0-1.283.939-2.22 2.061-2.22 1.107 0 1.976.937 1.976 2.22 0 1.27-.869 2.194-1.976 2.194zM51.078 29.647c2.046 0 3.714-1.546 3.714-3.643 0-2.11-1.668-3.642-3.714-3.642-2.047 0-3.715 1.531-3.715 3.642 0 2.097 1.668 3.643 3.715 3.643zm0-1.435c-1.122 0-2.089-.91-2.089-2.208 0-1.31.967-2.207 2.089-2.207 1.121 0 2.088.896 2.088 2.207 0 1.297-.967 2.208-2.088 2.208zM42.975 29.647c2.047 0 3.715-1.546 3.715-3.643 0-2.11-1.668-3.642-3.715-3.642-2.046 0-3.714 1.531-3.714 3.642 0 2.097 1.668 3.643 3.714 3.643zm0-1.435c-1.121 0-2.088-.91-2.088-2.208 0-1.31.967-2.207 2.088-2.207 1.122 0 2.089.896 2.089 2.207 0 1.297-.967 2.208-2.089 2.208zM33.331 29.647c1.711 0 3-.552 4.009-1.587 1.038-1.02 1.36-2.456 1.36-3.615 0-.358-.028-.69-.084-.966h-5.285v1.546h3.757c-.112.87-.406 1.503-.855 1.945-.547.538-1.402 1.131-2.902 1.131a4.088 4.088 0 01-4.121-4.11 4.088 4.088 0 014.121-4.112c1.248 0 2.159.482 2.832 1.103l1.107-1.09c-.939-.883-2.187-1.559-3.939-1.559-3.168 0-5.831 2.54-5.831 5.657 0 3.118 2.663 5.657 5.831 5.657z" />
        </g>
        <path
          d="M31.656 12.634a1.513 1.513 0 01-.552.438c-.14.07-.308.126-.504.173a3.06 3.06 0 01-.692.07 2.14 2.14 0 01-.819-.153 1.77 1.77 0 01-.639-.443 2.028 2.028 0 01-.416-.713 2.936 2.936 0 01-.148-.967v-.312c0-.36.045-.682.134-.965.09-.283.217-.523.384-.718.167-.195.371-.344.612-.446.241-.102.514-.153.82-.153.29 0 .541.037.755.112a1.453 1.453 0 01.892.795c.085.185.141.39.17.61h-.808a1.387 1.387 0 00-.097-.342.843.843 0 00-.187-.27.845.845 0 00-.293-.179 1.178 1.178 0 00-.415-.065 1.11 1.11 0 00-.503.107.938.938 0 00-.355.314 1.482 1.482 0 00-.212.508c-.046.201-.07.43-.07.685v.32c0 .26.028.49.085.691.056.201.137.37.242.506.106.137.234.241.384.313.151.071.322.107.513.107.141 0 .262-.009.363-.027.101-.019.186-.042.256-.07a.841.841 0 00.171-.093c.044-.034.08-.066.11-.096v-.928h-.978v-.625h1.797v1.816zm3.675-1.5h-1.947v1.458h2.276v.658h-3.099V8.51h3.076v.664h-2.253v1.31h1.947v.65zm4.424-1.96h-1.478v4.076h-.817V9.174h-1.465V8.51h3.76v.664zm3.151 4.076h-.82V8.51h.82v4.74zm4.437-4.076h-1.478v4.076h-.817V9.174h-1.465V8.51h3.76v.664zm6.064 1.83c0 .36-.047.683-.14.968a2.135 2.135 0 01-.4.726 1.738 1.738 0 01-.619.457c-.24.107-.507.16-.8.16-.29 0-.557-.053-.798-.16a1.77 1.77 0 01-.623-.457 2.1 2.1 0 01-.407-.726 2.997 2.997 0 01-.145-.968v-.24c0-.362.048-.685.145-.97.096-.288.231-.53.403-.73.173-.2.38-.353.621-.46.24-.106.506-.159.797-.159.293 0 .561.053.802.16.242.106.45.26.622.458.173.2.306.443.401.73.094.286.141.61.141.97v.241zm-.823-.248c0-.265-.026-.498-.077-.7a1.494 1.494 0 00-.223-.51.967.967 0 00-.36-.312 1.078 1.078 0 00-.483-.105c-.176 0-.334.035-.475.105a.998.998 0 00-.36.311 1.517 1.517 0 00-.228.51c-.053.203-.08.436-.08.701v.248c0 .264.027.5.08.703.053.204.13.375.23.512.1.138.221.242.363.313.142.07.301.106.477.106.364 0 .645-.139.841-.417.196-.278.295-.684.295-1.217v-.248zm5.403 2.494h-.823l-2.113-3.363v3.363h-.823V8.51h.823l2.12 3.376V8.51h.816v4.74z"
          fill={theme.palette.common.white}
        />
      </g>
    </svg>
  );
}

export default PlayStoreIcon;
